import { render, staticRenderFns } from "./WPRegionAdd.vue?vue&type=template&id=c24585d4&scoped=true&"
import script from "./WPRegionAdd.vue?vue&type=script&lang=js&"
export * from "./WPRegionAdd.vue?vue&type=script&lang=js&"
import style0 from "./WPRegionAdd.vue?vue&type=style&index=0&id=c24585d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24585d4",
  null
  
)

export default component.exports